// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"315":"ucare-panel-chunk","923":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"315":"4c91f9c4","787":"cda612ba","789":"675a4162","923":"50663174"}[chunkId] + ".chunk.js";
};